import React from 'react';
import { BannerReact } from 'common/components/banner';
import { ActionEvent, BannerAction, BannerTheme, BannerType } from 'common/components/banner/types';
import { ButtonTheme } from 'common/components/button/constants';
import { useTranslation } from 'common/i18n/hooks';
import { useExperimentPageContext } from 'apps/experiments/src/components/context';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { ExperimentPageBannerDecideModal } from './_decide-modal';
import { ExperimentLogBody } from './_log-body';
export function ExperimentPageBannerFailed() {
  const [open, setOpen] = React.useState(false);
  const i18n = useTranslation();
  const experiment = useExperimentsStore(state => state.experiment);
  const {
    canEdit
  } = useExperimentPageContext();
  if (!experiment) {
    return null;
  }
  return <>
      <BannerReact headerText={i18n.t("experiments.banner.failed.title")} theme={BannerTheme.Error} icon='x' type={BannerType.Embedded} multiline ctas={canEdit ? [{
      actionName: BannerAction.Custom,
      text: i18n.t("experiments.banner.common.edit-log"),
      theme: ButtonTheme.Tertiary
    }] : []} onAction={(ev: ActionEvent) => {
      if (ev.detail.actionName === BannerAction.Custom) {
        setOpen(true);
      }
    }} data-sentry-element="BannerReact" data-sentry-source-file="_failed.tsx">
        <div slot={"body-text"}>
          <ExperimentLogBody data-sentry-element="ExperimentLogBody" data-sentry-source-file="_failed.tsx" />
        </div>
      </BannerReact>
      {open && <ExperimentPageBannerDecideModal onClose={() => setOpen(false)} />}
    </>;
}